import { DataFetcher, PageDataContext, PageDataResult } from './types';
import axios from 'axios';
import { apiHost } from 'api/apiHost';

export const fundDetailsDataFetcher: DataFetcher = {
  templateIds: [
    '5827425C-1B42-46D1-9F13-11387A5BD4B3', // Automation vector
    '543D5F77-8AD4-4326-9E23-84804031CB3C', // Investments vector
    '023EE573-91D8-46DC-A139-7A3EB4157AAA', // Adviser vector
    'CF3F2635-270B-4977-9BB3-822AB90F1DCC', // Personal vector
    'E3590AD7-64A8-4980-A419-C4F1F926F9FC', // Global vector
  ],

  async fetchData(context: PageDataContext): Promise<PageDataResult> {
    console.log('Fund details data fetcher');
    // Extract ISIN code from slug (last part after final dash)
    const isinCode = context.slug.split('-').at(-1);

    const {
      language,
      fundsConfiguration: {
        countryInvestors: { countryCode, investorType, jurisdiction, literatureAuthorization },
      },
    } = context.sitecoreContext as any;

    const fundDetailsPayload = {
      CountryInvestors: {
        CountryCode: countryCode,
        InvestorType: investorType,
        Jurisdiction: jurisdiction,
        LiteratureAuthorization: literatureAuthorization,
      },
      language: language,
      isin: isinCode,
    };

    try {
      const fundDetailsData = {
        data: null,
        error: false,
      };

      const { data } = await axios.post(`${apiHost}/api/funds/funddetails`, fundDetailsPayload);

      if (data) {
        fundDetailsData.data = { ...data, isinCode };

        return {
          data: {
            fundDetailsData,
          },
          pageTitle: data.name,
          metaTitle: data.name,
        };
      }

      return {
        data: {
          fundDetailsData: {
            error: true,
            data: {},
          },
        },
      };
    } catch (e) {
      console.log('error during requesting fund details page', e);
      return {
        data: {
          fundDetailsData: {
            error: true,
            data: {},
          },
        },
      };
    }
  },
};
